import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {reduxForm} from 'redux-form';
import * as clientActions from 'redux/modules/clients';

var Datetime = require('react-datetime');

import Select from 'react-select';
//import 'react-select/dist/react-select.css';

import i18next from 'i18next';


import {
  Row, 
  Col, Button, Panel, OverlayTrigger, 
  Tooltip, Alert
} from 'react-bootstrap'; 



var MobileDetect = require('mobile-detect');

import _ from 'underscore';

import moment from 'moment';

import {ComProductList } from 'components';


import {linuxUserRules, createValidator, required, maxLength, email, noSpecialChars, noSpaces, minLength, isRightDate} from 'utils/validation';
 
import Toggle from "react-toggle-component"
import "react-toggle-component/styles.css" 
 
 
const validate = (values, props) => {
  const errors = {hyperUser:{}, ab:{}};
  
  var login = values.hyperUser.login;
  
  //errors['hyperUser']['prenom'] = required(values.hyperUser.prenom)
  //errors['hyperUser']['nom'] = required(values.hyperUser.nom)
  errors['hyperUser']['login'] = required(login)||noSpecialChars(login)||maxLength(16)(login)||linuxUserRules(login)
  errors['hyperUser']['password'] = props.action === 'update' ? undefined : required(values.hyperUser.password)
  errors['hyperUser']['email'] = required(values.hyperUser.email) || email(values.hyperUser.email)
  //errors['hyperUser']['telephone'] = required(values.hyperUser.telephone)
  
  
  
  
  errors['expiry_date'] = isRightDate(values.expiry_date)
  /*errors['rappel1']     = isRightDate(values.rappel1)
  errors['rappel2']     = isRightDate(values.rappel2)*/
      
  return errors
}


import { translate } from 'react-i18next';

@translate(['common'])
@connect(
  state => ({
    saveError: state.clients.saveError,
    modules: state.modules.data,
    comUpdateSuccess: state.clients.comUpdateSuccess,
    comUpdateError: state.clients.comUpdateError,
    sendingValidationSuccess:state.clients.sendingValidationSuccess,
    sendingValidationError:state.clients.sendingValidationError,
    sendingValidation:state.clients.sendingValidation,
    
    com_client_create_loading   :state.clients.com_client_create_loading,
    com_client_create_fail      :state.clients.com_client_create_fail,
    com_client_create_success   :state.clients.com_client_create_success,
    com_client_create_fail_msg  :state.clients.com_client_create_fail_msg,
    
  }),
  dispatch => bindActionCreators(clientActions, dispatch)
)
@reduxForm({
  form: 'client',
  fields: [
    'id', 'c_id',
    'hyperUser.login', 'hyperUser.email', 
    'hyperUser.telephone', 'hyperUser.nom', 
    'hyperUser.prenom', 'hyperUser.password','hyperUser.societe',
    'hyperUser.etat',
    
    'chk_com', 'chk_client',
  
    'expiry_date', 'rappel1', 'rappel2',
    
    'modules',    
  ],
  validate: validate,
  touchOnBlur  :true
})
export default class ComClientForm extends Component {
  
  
  constructor(props){
    super(props);
   
    this.comUpdateClient    = this.comUpdateClient.bind(this);
    this.onToggleLimit      = this.onToggleLimit.bind(this);
    this.onToggleDeactivate = this.onToggleDeactivate.bind(this);
    
    
    this.state = {
      showPassword:false,
      deactivate_account:false,
      limit_account:false,
      
    }
    
    if( props.action == 'update' ) {

      this.state = {
        showPassword:false,
        deactivate_account:props.client.hyperUser.etat == 3 ? true : false,
        limit_account:props.client.hyperUser.etat == 2 ? true : false
      }
          
          
    }
    
  }
  
  onToggleLimit(e){
    
    
    
    if( e == true ) { 
      
      this.props.fields.hyperUser.etat.onChange(2)
      
      this.setState({deactivate_account:false, limit_account:true})
      
    } else {
      this.setState({ limit_account:false})
      
      if( this.state.deactivate_account == true ) {
        this.props.fields.hyperUser.etat.onChange(3)
      } else {
        this.props.fields.hyperUser.etat.onChange(1)
      }
      
      
    }

  }
  
  onToggleDeactivate(e){
    
    
    if( e == true ) {
      this.props.fields.hyperUser.etat.onChange(3)
      
      this.setState({deactivate_account:true, limit_account:false})
      

    } else {
      this.props.fields.hyperUser.etat.onChange(1)
      
      this.setState({deactivate_account:false})
      
    }

  }
  
  
  comUpdateClient( values, client, dirtyFields ) {
    
 

    var {abonnement_id, cli_id, hyperUser} = this.props.client

    var sendDiff = false;
    
    //if( dirtyFields.length > 0 ) {
            
      /*if( confirm("Voulez-vous envoyer au client et aux commerciaux un email récapitulatif des changements que vous avez effectué ?")) {        
        sendDiff = true;
      }*/
      
      this.props.comUpdateClient(
        values, {abonnement_id, cli_id, hyperUser}, sendDiff, dirtyFields, this.props.user, this.props.modules
        
        ).then(()=>{this.props.loadCOMSupervisors(this.props.params);this.setState({showEmailPanel:false})});          

      


  }

  render() {
    const {
    	editStop, resetForm, 
    	fields, formKey, handleSubmit, invalid,
      pristine, save, submitting,
      saveError: { [formKey]: saveError },
      values, modules, comUpdateSuccess, comUpdateError,
      com_client_create_loading,
      com_client_create_fail,
      com_client_create_success,
      sendingValidationSuccess, 
      sendingValidation, 
      sendingValidationError,
      com_client_create_fail_msg, t
    } = this.props;
    
    const styles = require('containers/Client/Clients.scss');
    
    try {
      var md = new MobileDetect(window.navigator.userAgent);
    } catch(e){
      var md = null
    }
          
   
    var modulesOptions = modules.map((m)=>{ 
      return {"label":m.name, "value":m.id}
    })    
    
    
    if( this.props.action == 'update' ) {
      var btnText = t('comClientForm.update_client')
    } else {
      var btnText = t('comClientForm.create_client')
    }
    
    
    return (
      <form autoComplete="BLABLALLL"><Row>
        <Col xs={12} md={5}>
          <Row>
            <Col md={9} xs={12}>                            
              <label for="login"> {t('login.login')} *</label>

              <div className={this.props.action == 'update' ? "input-group":""}>
                <input autoComplete="new-password" name="login" type="text" className="form-control" {...fields['hyperUser']['login']} id="login"/>
                  
                {this.props.action == 'update' &&
                  <span className="input-group-addon">-{this.props.client.cli_id}-sup</span>
                }
              </div>
              {fields['hyperUser']['login'].error && fields['hyperUser']['login'].touched && <div className="text-danger">{fields['hyperUser']['login'].error}</div>}
            </Col>
          </Row>
          
          <br/>
          
          <Row>
            <Col md={9} xs={12}>
              <label for="password"> {t('login.password')} *</label>              
              <div className="input-group">                
                <input autoComplete="new-password" name="password" type={this.state.showPassword ? "text":"password"} className="form-control" {...fields['hyperUser']['password']} id="password"/>
                {fields['hyperUser']['password'].error && fields['hyperUser']['password'].touched && <div className="text-danger">{fields['hyperUser']['password'].error}</div>}
                <span className="input-group-addon"><i onClick={()=>this.setState({showPassword:!this.state.showPassword})} className={this.state.showPassword ? "fa fa-eye-slash" : "fa fa-eye"}/></span>
              </div>
              
            </Col>
          </Row>
          
          <br/>
          
          <Row>
            <Col md={9} xs={12}>
              <label for="email"> {t('main.email')} *</label> 
              <input name="email" type="text" className="form-control" {...fields['hyperUser']['email']} id="email"/>
              {fields['hyperUser']['email'].error && fields['hyperUser']['email'].touched && <div className="text-danger">{fields['hyperUser']['email'].error}</div>}
            </Col>
          </Row>
                    
          <br/>

          <Row>
            <Col md={9} xs={12}>
              <label for="prenom"> {t('main.firstname')}</label>
              <input name="prenom" type="text" className="form-control" {...fields['hyperUser']['prenom']} id="prenom"/>
              {fields['hyperUser']['prenom'].error && fields['hyperUser']['prenom'].touched && <div className="text-danger">{fields['hyperUser']['prenom'].error}</div>}
            </Col>
          </Row>
          <br/>
          <Row>
            <Col md={9} xs={12}>
              <label for="nom"> {t('main.lastname')}</label>
              <input name="nom" type="text" className="form-control" {...fields['hyperUser']['nom']} id="nom"/>
              {fields['hyperUser']['nom'].error && fields['hyperUser']['nom'].touched && <div className="text-danger">{fields['hyperUser']['nom'].error}</div>}
            </Col>
          </Row>
          
          <br/>
          
          <Row>
            <Col md={9} xs={12}>
              <label for="telephone"> {t('main.phone')}</label>
              <input name="telephone" type="text" className="form-control" {...fields['hyperUser']['telephone']} id="telephone"/>
              {fields['hyperUser']['telephone'].error && fields['hyperUser']['telephone'].touched && <div className="text-danger">
                {fields['hyperUser']['telephone'].error}</div>}
            </Col>
          </Row>
          
          <br/>
          
          <Row>
            <Col md={9} xs={12}>
              <label for="societe"> {t('main.society')}</label>
              <input name="societe" type="text" className="form-control" {...fields['hyperUser']['societe']} id="societe"/>
              {fields['hyperUser']['societe'].error && fields['hyperUser']['societe'].touched && 
                <div className="text-danger">{fields['hyperUser']['societe'].error}</div>
              }
            </Col>
          </Row>
          
          <br/>
          

          
          {/*(md && md.phone()) &&
            <Row>
              <Col xs={12}>
                {this.props.children}
              </Col>
            </Row>
         
          {/*
          {displayFormErrors(fields._meta.errors).length > 0 &&
          <Row>
            <Col md={9} xs={12}>
              <Alert bsStyle='danger'>              
                Il y a des erreurs dans le formulaire
              </Alert>
            </Col>
          </Row>
          
          }*/}
          
          
          
          
          
        <br/>
          
             
          
        </Col>
        {/*
        {(md &&!md.phone()) &&
          <Col md={6}>
            <br/>
            {this.props.children}
          </Col>
        }*/}
        
        
        <Col md={5}>
        
        <Row>
          <Col md={9} xs={12}>
            <label for="modules"> 
              {t('main.modules')}
            </label>
            
            <Select
              allowCreate={false}
              clearable={true}
              name="form-field-name"
              options={modulesOptions}
              
              multi={true}
              {...fields['modules']}
              onBlur={() => fields['modules'].onBlur(fields['modules'].value)}
            />
  
          </Col>
        </Row>
        <br/>
        <Row>
          <Col md={9} xs={12}>
            <label for="expiry_date"> {t('main.contract_date')} *</label>
            <Datetime className="" id="expiry_date"  style={{'width':'120px'}} {...fields['expiry_date']}  locale={i18next.language}
              onChange={(date)=>{                
                var date1 = JSON.parse(JSON.stringify(date));
                var date2 = JSON.parse(JSON.stringify(date));                    
                fields.expiry_date.onChange(date);
                fields.rappel1.onChange(moment(date1).subtract(3, 'months'))
                fields.rappel2.onChange(moment(date2).subtract(7, 'days'))                     
              }}
             ref="expiry_date" />

            {(values && moment(values.expiry_date).valueOf() < moment().valueOf()) && 
              <div><br/><Alert bsStyle="danger"><b> {t('main.expired_date')}</b></Alert></div>
            }
              
              {fields['expiry_date'].error && fields['expiry_date'].touched && <div className="text-danger">{fields['expiry_date'].error}</div>}
          </Col></Row>
          <br/> 
          
          <Row>
            <Col md={9} xs={12}>
              <label for="rappel1"> 
                {t('main.rappel1')}
                {(this.props.client && this.props.client.rappel1_sent!=null) && 
                <span className="text-primary">
                  <b> 
                    {t('main.reset')}(Email envoyé le {moment(this.props.client.rappel1_sent).format('DD-MM-YYYY HH:mm')})
                  </b>
                  </span>}
              </label>
              <Datetime id="rappel1" style={{'width':'120px'}} {...fields['rappel1']} inputProps={{disabled:false}} locale={i18next.language}/>
              {fields['rappel1'].error && fields['rappel1'].touched && <div className="text-danger">{fields['rappel1'].error}</div>}
            </Col>
          </Row>
          <br/>    
          <Row>
            <Col md={9} xs={12}>
              <label for="rappel2">Rappel 2 
                
                {(this.props.client && this.props.client.rappel2_sent!=null) && 
                
                  <span className="text-primary">
                    <b> 
                      {t('comClientForm.email_sent_at', {date:moment(this.props.client.rappel2_sent).format('DD-MM-YYYY HH:mm')})}
                    </b>
                  </span>
                  
                }
                
              </label>
              <Datetime id="rappel2" style={{'width':'120px'}} {...fields['rappel2']} inputProps={{disabled:false}} locale={i18next.language}/>
              {fields['rappel2'].error && fields['rappel2'].touched && <div className="text-danger">{fields['rappel2'].error}</div>}
            </Col>
          </Row>
          <br/>    
          

        <br/>
        <Row>
          <Col md={6} xs={12}>
            <label for="etat"> {t('comClientForm.account_state')}</label><br/>
            {/*<input type="radio" {...fields['hyperUser']['etat']} value="1" checked={fields['hyperUser']['etat'].value == '1'}/> Actif &nbsp;
            <input type="radio" {...fields['hyperUser']['etat']} value="0" checked={fields['hyperUser']['etat'].value == '0'}/> Inactif &nbsp;
            <input type="radio" {...fields['hyperUser']['etat']} value="2" checked={fields['hyperUser']['etat'].value == '2'}/> Suspendu*/}
            
            
            {/*<p>Restreindre le compte limitera le client et ses utilisateurs à une lecture seul des fiches, désactiver le compte empechera la connexion à leurs compte même avant la fin de contrat</p>*/}
            
            <Toggle name="limit_account" labelRight={t("main.restricted")} label="Normal" checked={this.state.limit_account}  onToggle={this.onToggleLimit} />
            
            <br/>
            <Toggle name="deactivate_account" labelRight={t("main.deactivated")} label={t('activated')} checked={this.state.deactivate_account} onToggle={this.onToggleDeactivate}/>
            
          </Col>  
        </Row>
        
        
        <br/>
        {this.props.action == 'update' &&

          <Panel collapsible header={<h3> {t('comClientForm.clientProducts')} ({this.props.products.length})</h3>}>
            {this.props.products.length > 0 &&<ComProductList products={this.props.products} />}
          </Panel>
          
        }
        </Col>
      </Row>
      
      <Row>
      
      <Col md={4} xs={12}>
        
        
        <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">
           <b>{btnText}</b>
          </Tooltip>}>
      
        <button className="btn btn-success" disabled={invalid==true}
          onClick={handleSubmit(() =>{

           if( this.props.action != 'update' ) {
             this.props.comCreateClient(values)
             .then(result => {
               if (result && typeof result.error === 'object') {
                 return Promise.reject(result.error);                   
               } else {
                 this.props.loadCOMSupervisors(this.props.params)
               }
               
               
               setTimeout(()=>window.history.back(), 3000)
             })
           } else {                                                       
             this.setState({showEmailPanel:true})                                      
           }
 
          }
          )}
         >
        

        <i className={'fa ' + (submitting ? 'fa-cog fa-spin' : 'fa-floppy-o')}/>
          
          
        </button></OverlayTrigger>
        
        &nbsp;
        
        {this.props.action == 'update' &&
        
          <span className="pull-right">&nbsp;
          
            <OverlayTrigger placement="top" overlay={
              <Tooltip id="tooltip">
            
                <strong> 
                  {t('main.validation_email_desc')}
                  
                </strong>
              
              
              </Tooltip>}>
            
            
              <button className="btn btn-primary" disabled={invalid || this.props.client.hyperUser.validated === 1}
                onClick={handleSubmit(() =>{
                  
                  if( this.props.action == 'create' ) {
                    this.props.sendValidationEmail(values);
                    return
                  }
                  
                  if( this.props.client.hyperUser.validated === 0 ) {
                    if( confirm( t('main.email_already_sended', {email1:this.props.client.hyperUser.validation_email, email2:values.hyperUser.email})) ) {
                      this.props.sendValidationEmail(values)
                    }
                  } else if( this.props.client.hyperUser.validated === 1 ) {
                    if( confirm( t('main.validation_email_already_used', {email1:this.props.client.hyperUser.validation_email, email2:values.hyperUser.email})) ) {
                      this.props.sendValidationEmail(values)
                    }
                  
                  } else {
                    if( confirm( t('main.please_confirm')) ) {
                      this.props.sendValidationEmail(values)
                    }
                    
                  }
        
                })}
                
               >
                <i className="fa fa-envelope"/>  {t('comClientForm.validate_email')}
              </button>
            </OverlayTrigger>
          </span>
        }
    

        
        <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">
        <b> {t('main.reset')}Reset</b>
       </Tooltip>}>
        
        <button className="btn btn-danger"
          onClick={resetForm}>
            <i className="fa fa-ban"/>
        </button>
            
            </OverlayTrigger>
            
        <br/>
        
        {this.state.showEmailPanel &&                
          <Row>
            <br/>
            <Alert bsStyle="info">
              <h4> {t('main.warn_by_email')} : </h4>
              <input type="checkbox" ref="chk_com" {...fields['chk_com']}/>  {t('main.commercials')} &nbsp;
              <input type="checkbox" ref="chk_client" {...fields['chk_client']}/>  {t('main.clients')} &nbsp;
              {/*<input type="checkbox" ref="chk_nobody" {...fields['chk_nobody']}/> Personne*/}
              
              
              <Button bsStyle="primary" onClick={handleSubmit(() =>{
                                      
                var dirtyFields = [];
                
                for (var key in fields ) {
                  var field = fields[key];                        
                  if( field.dirty == true && field.name.indexOf('chk') < 0 ) {
                    dirtyFields.push(field)
                  }                        
                }                      
                
                for (var key in fields['hyperUser'] ) {
                  var field = fields['hyperUser'][key];
                  field.name = field.name.split('.')[1]
                  if( field.dirty == true ) {
                    dirtyFields.push(field)
                  }                        
                }

                this.comUpdateClient(values, this.props.client, dirtyFields);
              })}> {t('main.validate')}</Button>
              
            </Alert>
          </Row>
        }
        <br/>
        <Row>
          <Col md={5} xs={12}>
            <p>
              {com_client_create_success &&
                <div className="alert alert-success" role="alert">                  
                   {t('comClientForm.success_client_created')}
                </div>
              }
              
              {com_client_create_fail &&
                <div className="alert alert-danger" role="alert">                  
                  <span> 
                    {t('comClientForm.error_client_created')}<br/>
                    {com_client_create_fail_msg}</span>
                </div>
              }
            </p>
          </Col>
        </Row>
        
        
        {comUpdateError||comUpdateSuccess &&
        
        <Row>
        <br/>
        <Col md={9} xs={12}>
        
          {comUpdateError &&
            <div className="alert alert-danger" role="alert">
              <span className="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span>
              {t('comClientForm.error_update')}
            </div>
          }
              
          {comUpdateSuccess &&
            <div className="alert alert-success" role="alert">                  
               {t('comClientForm.success_client_updated')}
            </div>
          }
                                                                  
          {sendingValidationSuccess &&
            <div className="alert alert-success" role="alert">                  
               {t('comClientForm.success_email_send')}
            </div>
          }
        </Col>
       
      
      </Row>}
        


        
        
      </Col>
      
      
      <Row>
      
        <Col md={12} xs={12}>
      
          {this.props.action == 'update' ?
            <div><br/>
            <button className="btn btn-warning"
              onClick={() => {editStop(formKey);this.props.loadCOMSupervisors(this.props.params)}}
              disabled={submitting}>
                <i className="fa fa-arrow-left"/> {t('main.back_to_list')}
            </button>&nbsp;</div>
          
           
          

            : <div><br/>
            <button className="btn btn-warning"
              onClick={() => window.history.back()}
              disabled={submitting}>
                <i className="fa fa-arrow-left"/> {t('main.back_to_list')}
            </button>&nbsp;</div>
          }
        
        </Col>
        
      
      </Row>
      
      
      
    </Row>
    
    
    </form>
    
      
      
    );
  }
}


function displayFormErrors(errors){
    
  var content = [];
  
  _.each(errors, (deep)=>{
    
    _.each(deep, (value, key)=>{
      
      content.push(<div>{key} : {value}</div>)

    })
    
  })
  
  
  return content
  
}
